const defaultNames: Record<string, string[]> = {
    'windows': ['Windows', 'tdesktop', 'Win32', 'Win64'],
    'mac': ['Mac', 'macos', 'MacIntel', 'MacArm'],
    'linux': ['universal'],
    'android': ['Android', 'Linux', 'Linux aarch64'],
    'ios': ['iOS', 'ios'],
    'iphone': ['iPhone', 'ios'],
    'ipad': ['iPad', 'ios'],
    'unknown': ['unknown', 'web'],
}

export const getOs = (): string => {
    const osName = findOs(getOsNative());
    console.log("result os name: " + osName);
    return osName;
}

export const findOs = (value: string): string => {
    return Object.keys(defaultNames)
        .find(key => defaultNames[key].includes(value)) ?? 'unknown';
}

const getOsNative = (): string => {
    const osPre = globalThis.window?.navigator.platform;
    const possibleMainName = osPre.split(" ")[0];
    console.log("OS Pre: " + possibleMainName);
    return possibleMainName || 'unknown';
}